import React from 'react';
import { render } from 'react-dom';
import styles from './webgl-modal.css';
import tips from './unsupported.png';
import close from './close.png';

class BrowserBox {

    static close() {
        document.getElementById('unsupported').style.display = 'none';
    }

    static show() {
        const doc = window.document
        const node = doc.createElement('div')
        node.id = 'unsupported' // 保证打开唯一的窗口
        if (doc.getElementById('unsupported')) {
            return
        }
        doc.body.appendChild(node)
        render((
            <div className={styles.onlyChrome}>
                <div className={styles.modalBg}></div>
                <div className={styles.browserTips}>
                    <div className={styles.tipsBox}>
                        <img src={tips}></img>
                        <img onClick={()=>window.browserClose()} src={close}></img>
                    </div>
                    <div className={styles.tipsContent}>
                        当前浏览器版本可能影响部分功能正常使用，建议使用Chrome浏览器
                    </div>
                    <span onClick={() => window.open('https://www.google.cn/intl/zh-CN/chrome/', '_blank')} className={styles.download}>前往下载</span>
                </div>
            </div>
        ), node)
    }
}

// 挂载到window对象
window.browser = BrowserBox.show
window.browserClose = BrowserBox.close

export default BrowserBox
